// extracted by mini-css-extract-plugin
export default {"Small":"style_Small__qoY9j","unchecked":"style_unchecked__vlkLV","checked":"style_checked__S4tNL","indeterminate":"style_indeterminate__65BSU","disabled":"style_disabled__mTq+S"};